import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { User } from 'app/models/user.model';
import { Comment } from 'app/models/comment.model';

@Component({
  selector: 'app-communication-comment',
  templateUrl: './communication-comment.component.html'
})
export class CommunicationCommentComponent implements OnInit {
    @Input() comments: Comment[]= [];
    @Input() users: User[] = [];
    @Output() send = new EventEmitter<Comment>();

    replyMode = false;

    get commentsArray(): Comment[] {
        return this.comments;
    }

    ngOnInit(): void {

    }

    trackByFn(index: number, item: any): any
    {
        return item.id || index;
    }

    toggleReplyMode(): void
    {
        this.replyMode = !this.replyMode;
    }

    canReply(comment): boolean {
        return comment.parent_id === null && !this.replyMode;
    }

    isReplyOpen(comment): boolean {
        return comment.parent_id === null && this.replyMode;
    }

    sendReply($event: Comment, comment: Comment): void {
        $event.parent_id = comment.id;
        this.send.emit(new Comment($event));
        this.toggleReplyMode();
    }

    getUsername(comment: Comment): string {
        const commentUser: User = this.users.find(user => user.id === comment.user_id);
        return commentUser ? commentUser.prenom + ' ' + commentUser.nom : '';
    }
}
